// All action types

const room = {
  REQUEST_ROOMS: 'REQUEST_ROOMS',
  REQUEST_PREVIOUS_ROOMS: 'REQUEST_PREVIOUS_ROOMS',
  RECEIVE_UPCOMING_ROOMS: 'RECEIVE_UPCOMING_ROOMS',
  RECEIVE_PREVIOUS_ROOMS: 'RECEIVE_PREVIOUS_ROOMS',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  SELECT_CONFERENCE: 'SELECT_CONFERENCE',
  REQUEST_CONFERENCE_DETAILS: 'REQUEST_CONFERENCE_DETAILS',
  RECEIVE_CONFERENCE_DETAILS: 'RECEIVE_CONFERENCE_DETAILS',
  REQUEST_PARTICIPANT_LIST: 'REQUEST_PARTICIPANT_LIST',
  RECEIVE_PARTICIPANT_LIST: 'RECEIVE_PARTICIPANT_LIST',
  REQUEST_RECORD_LIST: 'REQUEST_RECORD_LIST',
  RECEIVE_RECORD_LIST: 'RECEIVE_RECORD_LIST',
  SCHEDULE_SUBMITTED: 'SCHEDULE_SUBMITTED'
}

export default room



// WEBPACK FOOTER //
// ./src/routes/Room/actions/actionTypes.js